<template>
    <v-container fluid>
        <v-row v-if="showReportRules">
            <v-col cols="12"
                   md="3"
                   v-for="document in reportRules"
                   :key="document.id"
                   pa-2>
                <DocumentFileContainer
                        :elevation="2"
                        @click="selected === document.id ? selected = '' : selected=document.id"
                        :setDocumentRule="document"
                        :ref="document.id"
                        :setDocumentFile="document"
                        @document-changed = "updateDocument($event, document)"
                        :required = "1"
                        :belong="client.id"
                        :document_type="DOCUMENT_FILE_TYPE.REPORT"
                        :display_name="document.name"
                        :created_by="getCreatedBy"
                        :entity_type="DOCUMENT_FILE_ENTITY_TYPE.CLIENT"
                        :requiresApproval="document.approvalRequired"
                ></DocumentFileContainer>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="6" sm="2">
                <v-btn color="default" text @click="close">Cancel</v-btn>
            </v-col>
            <v-col cols="6" sm="2">
                <v-btn color="primary"
                       :loading="isSaving"
                       :disabled="isSaving"
                       @click="save">Save</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {DOCUMENT_FILE_TYPE, DOCUMENT_FILE_ENTITY_TYPE} from "@/shared/enums/DocumentFile";
    import {FORM_STATUS} from "@/shared/enums/FormStatuses";
    import {EmployeeClientReport} from "@/shared/dtos/Dtos";
    import alertEventBus from "@/eventBus/AlertEventBus";
    import FileHandler from '@/fileHandler/Handler';
    import {USER_TYPE} from "@/shared/enums/UserType";
    const DocumentFileContainer = ()=> import(  '@/components/common/DocumentFilesContainer');

    export default {
        name: "ReportUploadForm",
        props:['id',"entity_id", "type","reports"],
        components:{ DocumentFileContainer },
        data(){
            return {
                client: {},
                employee: {},
                groupType: {},
                reportGroups:{},
                reportRules:{},
                showReportRules: false,
                isSaving: false,
                reportRulesFiles: {},
                employeeClientReport: EmployeeClientReport
            };
        },
        validations:
        {

        },
        computed:
        {
            entityId(){
                // return this.client.id;
                return this.entity_id;
            },
            entityType(){
                return DOCUMENT_FILE_ENTITY_TYPE[this.type.toUpperCase()];
            },
            pathId(){
                return this.id;
            },
            userID(){
                return this.entityType === USER_TYPE.CLIENT ? this.client.id : this.employee.id;
            },
            DOCUMENT_FILE_TYPE(){
                return DOCUMENT_FILE_TYPE;
            },
            getCreatedBy(){
                return this.employee.cognitoUsername
            },
            DOCUMENT_FILE_ENTITY_TYPE(){
                return DOCUMENT_FILE_ENTITY_TYPE;
            }
        },
        methods:
        {
            async initialize()
            {
                if(this.$route.query.reports == undefined || !this.$route.query.reports.length)
                    this.close();

                this.getEntityData();
            },
            close()
            {
                this.resetValues();
                this.status = FORM_STATUS.CLOSE;

                //going to redirect route
                if(this.$route.query.redirect !== undefined && this.$route.query.redirect !== '')
                {
                    this.$router.push({name:this.$route.query.redirect});
                    return;
                }

                this.$router.go(-1);
            },
            async getEntityData()
            {
                try{
                    await this.$store.dispatch('getEmployee', {id: (this.entityType === USER_TYPE.CLIENT ? this.entityId : this.pathId)});
                    await this.$store.dispatch('getClient', {id: (this.entityType === USER_TYPE.CLIENT ? this.pathId : this.entityId)});
                    this.client = this.$store.getters.getClient;
                    this.employee = this.$store.getters.getEmployee;

                    this.getReportRules();
                }catch (e) {
                    alertEventBus.setAlert({type:'error', msg: e.message});
                }

            },
            async getReportRules()
            {
                let reportsId = !Array.isArray(this.$route.query.reports) ? [this.$route.query.reports] : this.$route.query.reports;
                try
                {
                    for(let reportRule in reportsId)
                    {
                        let reportRuleId = reportsId[reportRule];
                        await this.$store.dispatch('getDocumentRule', {id:reportRuleId});
                        this.reportRules[reportRuleId] = this.$store.getters.getDocumentRule;
                    }

                    this.showReportRules = true;
                }
                catch (e) {
                    alertEventBus.setAlert({type:'error', msg: e.message});
                }
            },
            resetValues()
            {
                this.$v.$reset();
            },
            updateDocument(newDocumentFile, document){
                this.reportRulesFiles[document.id] = {...newDocumentFile};
            },
            async save() {
                //call each component validate method
                let hasErrors = false;
                for(let doc in this.reportRules) {
                    let child = this.$refs[doc][0];
                    hasErrors = await child.validate() || hasErrors;
                }

                this.$v.$touch();
                if(this.$v.$anyError || hasErrors || Object.keys(this.reportRulesFiles).length === 0)
                    return;

                this.isSaving = true;

                try {
                    /**
                     * Uploading document files and creating the entity EmployeeClientReport
                     */
                    let documentErrors = [];
                    for(let document in this.reportRulesFiles)
                    {
                        if(this.reportRulesFiles[document].hasOwnProperty('file_id'))
                        {
                            try
                            {
                                //uploading document
                                let metadata = {...this.reportRulesFiles[document].metadata};
                                metadata.issue_date = this.reportRulesFiles[document].issue_date;
                                metadata.status = this.reportRulesFiles[document].status;
                                metadata.type = DOCUMENT_FILE_TYPE.REPORT;

                                await FileHandler.createFile('Report', this.reportRulesFiles[document].file, metadata);

                                //creating the ReportEmployeeClient entity
                                let employeeClientReport = {...EmployeeClientReport};
                                employeeClientReport.employeeId = this.employee.id;
                                employeeClientReport.clientId = this.client.id;
                                employeeClientReport.clientName = `${this.client.name} ${this.client.family_name}`;
                                employeeClientReport.employeeName = this.employee.name;
                                employeeClientReport.status = this.reportRulesFiles[document].status;
                                employeeClientReport.requiredLogHours = this.reportRulesFiles[document].requiredLogHours;
                                employeeClientReport.reportId = document;
                                employeeClientReport.documentFile = {
                                    id: this.reportRulesFiles[document].file_id,
                                    reportRuleName: this.reportRulesFiles[document].documentRule,
                                    name: this.reportRulesFiles[document].file.name
                                };

                                await this.$store.dispatch('setReport', employeeClientReport);
                            }
                            catch (e) {
                                documentErrors.push(this.documentFiles[document].name);
                            }
                        }
                    }
                }
                catch (e) {
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    this.isSaving = false;
                    return;
                }

                this.close();
            },
        },
        async created()
        {
            this.initialize();
        }
    }
</script>

<style>
    .v-chip.white-span span {
        color: white !important;
    }
</style>